import React, { useState } from 'react';
import { Alert, Box, IconButton, Collapse } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useActiveAnnouncements } from '../hooks/useQueries';

interface Announcement {
  id: number;
  message: string;
  severity: string;
  startDate: string;
  endDate: string;
}

const AnnouncementBanner: React.FC = () => {
  const { data: announcements = [] } = useActiveAnnouncements();
  const [dismissed, setDismissed] = useState<Set<number>>(new Set());

  const handleDismiss = (id: number) => {
    setDismissed(new Set(dismissed).add(id));
  };

  const visibleAnnouncements = announcements.filter((a: any) => !dismissed.has(a.id));

  if (visibleAnnouncements.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: '100%' }}>
      {visibleAnnouncements.map((announcement: any) => (
        <Collapse key={announcement.id} in={true}>
          <Alert
            severity={announcement.severity as any || 'info'}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => handleDismiss(announcement.id)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 1, borderRadius: 0 }}
          >
            {announcement.message}
          </Alert>
        </Collapse>
      ))}
    </Box>
  );
};

export default AnnouncementBanner;
